import { Card, EmptyState, Page, Spinner } from '@shopify/polaris';
import React from 'react';
import '/assets/styles/loader.css';

type NoOrderDataProps = { title: string; msg?: string; loading?: boolean };

export const NoOrderData = ({ title, msg, loading }: NoOrderDataProps) => {
  return (
    <Page>
      <Card>
        <div style={{ paddingTop: 40 }} />
        <EmptyState
          heading={title}
          image={loading ? '' : '/assets/icons/file-cross.png'}
        >
          {loading ? <Spinner /> : msg}
        </EmptyState>
      </Card>
    </Page>
  );
};

export const SimpleLoader = () => {
  return (
    <div className="loaderContainer">
      <Spinner size="large" />
    </div>
  );
};
